<template>
    <div class="col-12 row form-group">
        <div class="col-6">
            <label class="my-0 mt-2" for="input-live">Type</label>
            <v-select id="type" label="name" :multiple="false" v-model="type" :options="searchList"></v-select>
        </div>
        <div class="col-6">
            <label class="my-0 mt-2" for="input-live">Search</label>
            <input  class="form-control" id="search" type="text" v-model="search"/>
        </div>
        <div class="col-6">
            <label class="my-0 mt-2" for="input-live">Day</label>
            <v-select id="day" label="name" :multiple="false" v-model="day" :options="dayList"></v-select>
        </div>
    </div>
</template>

<script>
  import Datepicker from 'vuejs-datepicker';
  export default {
    components: {
      Datepicker,
    },
    props: {
      filterTab: Number,
      module:String
    },
    data() {
      return {
        searchList:[
            {
              "name":"Tracking Code",
              "value":"tracking_id"
            },
            {
              "name":"To/CC/BCC",
              "value":"to_bcc_cc"
            },
            {
              "name":"From",
              "value":"from"
            }
        ],
        // dayList:[1,3,5,7,10,30,90],
        dayList:[
            {
              "name":"1 Days",
              "value":1
            },
            {
              "name":"3 Days",
              "value":3
            },
            {
              "name":"5 Days",
              "value":5
            },
            {
              "name":"7 Days",
              "value":7
            },
            {
              "name":"10 Days",
              "value":10
            },
            {
              "name":"30 Days",
              "value":30
            },
            {
              "name":"90 Days",
              "value":90
            },
        ],
        day:{
              "name":"90 Days",
              "value":90
            },
        type:{
              "name":"Tracking Code",
              "value":"tracking_id"
            },
        search:""
      };
    },

    watch: {
    },
    mounted() {
    },
    methods: {
      getFilter() {
        var typeSearch=""
        var daySearch=""
        if(this.type !=null && this.type !=""){
            typeSearch=this.type.value
        }
        if(this.day !=null && this.day !=""){
            daySearch=this.day.value
        }
        let object = {
          type:typeSearch,
          day:daySearch,
          search:this.search,
        };
        return object;
      },
    },
  };
</script>

<style></style>
